import {
  PenTool,
  Monitor,
  Code2,
  Server,
  Database,
  Cpu,
  FileSignature,
  ShieldCheck,
  GlobeLock,
  Gavel,
  Building2,
  Briefcase,
  FileText,
  ClipboardList,
  BookOpenCheck,
  Scale,
  Phone,
  MessageSquare,
  Inbox,
  Headphones,
  CalendarClock,
  User,
  Settings,
  Globe2,
  Zap,
  Layers,
} from "lucide-react";

import type { LucideIcon } from "lucide-react";

export type IconCategoryKey =
  | "design"
  | "dev"
  | "legal"
  | "business"
  | "comms"
  | "misc";

export interface IconDef {
  key: string;
  label: string;
  category: IconCategoryKey;
  Icon: LucideIcon;
}

const LayoutIcon: LucideIcon = Monitor;
const PaletteIcon: LucideIcon = Settings;

export const ICON_DEFS: IconDef[] = [
  { key: "design.ui", label: "UI / UX", category: "design", Icon: PenTool },
  { key: "design.wireframe", label: "Wireframing", category: "design", Icon: LayoutIcon },
  { key: "design.prototype", label: "Prototyping", category: "design", Icon: Monitor },
  { key: "design.brand", label: "Brand / Visual", category: "design", Icon: PaletteIcon },

  { key: "dev.fullstack", label: "Fullstack", category: "dev", Icon: Code2 },
  { key: "dev.backend", label: "Backend", category: "dev", Icon: Server },
  { key: "dev.frontend", label: "Frontend", category: "dev", Icon: Monitor },
  { key: "dev.api", label: "API / Integrasjoner", category: "dev", Icon: Database },
  { key: "dev.architecture", label: "Arkitektur", category: "dev", Icon: Cpu },

  { key: "legal.contracts", label: "Kontrakter", category: "legal", Icon: FileSignature },
  { key: "legal.compliance", label: "Compliance", category: "legal", Icon: ShieldCheck },
  { key: "legal.gdpr", label: "GDPR", category: "legal", Icon: GlobeLock },
  { key: "legal.disputes", label: "Tvister", category: "legal", Icon: Gavel },
  { key: "legal.corporate", label: "Selskapsrett", category: "legal", Icon: Building2 },

  { key: "business.strategy", label: "Strategi", category: "business", Icon: Briefcase },
  { key: "business.finance", label: "Finans", category: "business", Icon: FileText },
  { key: "business.operations", label: "Drift", category: "business", Icon: ClipboardList },
  { key: "business.training", label: "Opplæring", category: "business", Icon: BookOpenCheck },
  { key: "business.management", label: "Ledelse", category: "business", Icon: Scale },

  { key: "comms.phone", label: "Telefoni", category: "comms", Icon: Phone },
  { key: "comms.chat", label: "Chat", category: "comms", Icon: MessageSquare },
  { key: "comms.email", label: "E-post", category: "comms", Icon: Inbox },
  { key: "comms.support", label: "Support", category: "comms", Icon: Headphones },
  { key: "comms.meetings", label: "Møter", category: "comms", Icon: CalendarClock },

  { key: "misc.user", label: "Person", category: "misc", Icon: User },
  { key: "misc.settings", label: "Settings", category: "misc", Icon: Settings },
  { key: "misc.global", label: "Global", category: "misc", Icon: Globe2 },
  { key: "misc.performance", label: "Ytelse", category: "misc", Icon: Zap },
  { key: "misc.layered", label: "Lag / Struktur", category: "misc", Icon: Layers },
];

export const ICON_MAP: Record<string, IconDef> = ICON_DEFS.reduce(
  (acc, def) => {
    acc[def.key] = def;
    return acc;
  },
  {} as Record<string, IconDef>
);

export const ICON_CATEGORY_LABELS: Record<IconCategoryKey, string> = {
  design: "Design",
  dev: "Utvikling",
  legal: "Juridisk",
  business: "Business",
  comms: "Kommunikasjon",
  misc: "Annet",
};
